import { ShieldAlert, CreditCard, LogOut, Phone } from 'lucide-react';
import RenewalForm from '../components/RenewalForm';
import DynamiCFormModal from '../components/DynamicFormModal'; // Assuming this is the correct path
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { useAuth } from '../context/authContext';
const SubscriptionExpiredPage = () => {
    const { user } = useAuth();
    const { renewSubscriptino } = useAuth();
    const navigate = useNavigate();
    console.log(user);
    const handleOpenRenewModal = () => {
        const modal = document.getElementById('subscription-renewal-modal');
        if (modal) {
            modal.showModal();
        }
    }

    const handleLogout = async () => {
        try {
          const res = await fetch(SummaryApi.logout.url, {
            method: SummaryApi.logout.method,
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
          });
          if (res.ok) {
            localStorage.removeItem("authToken");
            toast.success("Logout successful");
            navigate("/login");
          } else toast.error("Logout failed");
        } catch (err) {
          toast.error("Network error");
        }
      };
      if (!user) {
        // You can return a full loading spinner component if you want
        return (
            <div className="flex items-center justify-center min-h-screen">
                Loading...
            </div>
        );
    }

    return (
        <>
            <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
                <div className="w-full max-w-lg p-8 sm:p-12 text-center bg-white rounded-lg shadow-xl">
                    
                    <ShieldAlert className="w-16 h-16 mx-auto text-red-500" strokeWidth={1.5} />
                    
                    <h1 className="mt-4 text-3xl font-bold text-gray-800">
                        Your Subscription Has Expired
                    </h1>
                    
                    <p className="mt-4 text-lg text-gray-600">
                        {/* Removed dynamic name, as currentUser prop is gone */}
                        Hi {user.name}, your access to the dashboard and all features is now restricted.
                    </p>
                    
                    {/* --- Actions --- */}
                    <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            onClick={handleOpenRenewModal} // This logic is self-contained
                            className="flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700"
                        >
                            <CreditCard className="w-5 h-5 mr-2" aria-hidden="true" strokeWidth={2} />
                            Click to Renew Subscription
                        </button>
                        <button
                            onClick={handleLogout}
                            className="flex items-center justify-center w-full px-6 py-3 text-base font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md shadow-sm hover:bg-gray-200"
                        >
                            <LogOut className="w-5 h-5 mr-2" aria-hidden="true" strokeWidth={2} />
                            Logout
                        </button>
                    </div>

                    {/* --- Contact Info Text --- */}
                    <div className="mt-8 pt-6 border-t border-gray-200">
                        <p className="text-sm text-gray-600 flex items-center justify-center flex-wrap gap-2">
                            <Phone className="w-4 h-4 text-gray-500" />
                            Your subscription has expired. Please contact the admin to renew. Call +91 9309140606
                        </p>
                    </div>

                </div>
            </div>

            {/* --- Renewal Modal --- */}
            <DynamiCFormModal id={"subscription-renewal-modal"} title={"Renew Your Subscription"}>
                <RenewalForm 
                    currentUser={user}
                    onRenew={async(renewData)=>{
                        const success = await renewSubscriptino(renewData);

                        if(success){
                            // document.getElementById('subscription-renewal-modal').close()
                            // it will unmount this whole componenet 
                            // coz in parent state changed to Active and wokrs fine
                            console.log('subscribed');
                        }
                    }}
                />
            </DynamiCFormModal>
        </>
    );
}

export default SubscriptionExpiredPage;